import { render, staticRenderFns } from "./StudentNoticeView.vue?vue&type=template&id=63e5618a"
import script from "./StudentNoticeView.vue?vue&type=script&lang=js"
export * from "./StudentNoticeView.vue?vue&type=script&lang=js"
import style0 from "./StudentNoticeView.vue?vue&type=style&index=0&id=63e5618a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports